<template>
    <modal
      name="IPRoleExport"
      transition="nice-modal-fade"
      @before-open="beforeOpen"
      :classes="['custom']"
      :clickToClose="false"
      :width="636"
      :height="'auto'"
      :min-height="400"
    >
        <div class="export-box">
            <div>
              您的作品中包含{{ ipPayedCount }}种已单次付费的IP形象，这些形象只能导出1次，再次导出还需要付费，请核对作品无误后再导出。
            </div>
            <div class="btn-box">
              <div
                class="cancel-btn"
                @click="cancelBtn"
              >取消</div>
              <div
                class="confirm-btn"
                @click="exportBtn"
              >确认导出</div>
            </div>
        </div>
    </modal>
  </template>
  
  <script>
//   import { mapGetters } from 'vuex'; 
  export default {
    data () {
      return {
        ipPayedCount: 0
      }
    },
    computed: {
    //   ...mapGetters([
    //     'UserMsg'
    //   ])
    },
    created () {
  
    },
    methods: {
      beforeOpen (ev) {
        this.ipPayedCount = ev.params.ipPayedCount
      },
      cancelBtn() {
        this.$modal.hide('IPRoleExport');
      },
      exportBtn() {
        this.$modal.hide('IPRoleExport');
        this.$bus.emit('exportVideo');
      }
    }
  }
  </script>
  
  <style lang="scss" scoped>
  .export-box {
    width: 464px;
    height: 219px;
    background: #ffffff;
    border-radius: 4px;
    padding: 48px 32px;
    font-size: 16px;
}
.btn-box {
    margin-top: 36px;
    display: flex;
    justify-content: center;
    align-items: center;
    .cancel-btn {
        width: 116px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        background: #F2F3F7;
        margin-right: 30px;
        &:hover {
            cursor: pointer;
        }
    }
    .confirm-btn {
        width: 116px;
        height: 36px;
        line-height: 36px;
        border-radius: 4px;
        text-align: center;
        font-size: 14px;
        color: #ffffff;
        background: #6464F8;
        &:hover {
            background: #7979f8;
            cursor: pointer;
        }
    }
}
  </style>
  


// WEBPACK FOOTER //
// src/components/emodal/IPRolePay/IPRoleExport.vue